<app-modal
  [isOpen]="isOpen()"
  title="Entre na sua Conta"
  (closed)="onClose()"
>
  <form (ngSubmit)="onSubmit()" class="login-form">
    @if (errorMessage()) {
      <p class="error-message" role="alert">{{ errorMessage() }}</p>
    }
    <div class="field-area" [class.invalid-area]="!!errorMessage()">
      <label class="field-label">E-mail</label>
      <input
        type="email"
        class="field-input"
        placeholder="(ex.: email@givo.com)"
        [maxlength]="limits.email"
        [ngModel]="email()"
        (ngModelChange)="email.set($event); clearError()"
        name="email"
        autocomplete="email"
        [attr.aria-invalid]="!!errorMessage()"
      />
    </div>

    <div class="field-area" [class.invalid-area]="!!errorMessage()">
      <label class="field-label">Senha</label>
      <div class="password-wrap">
        <input
          [type]="showPassword() ? 'text' : 'password'"
          class="field-input"
          placeholder="Senha"
          [maxlength]="limits.passwordMax"
          [ngModel]="password()"
          (ngModelChange)="password.set($event); clearError()"
          name="password"
          autocomplete="current-password"
          [attr.aria-invalid]="!!errorMessage()"
        />
      <button type="button" class="password-toggle" (click)="togglePassword()" [attr.aria-label]="showPassword() ? 'Ocultar senha' : 'Mostrar senha'">
        @if (showPassword()) {
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
          </svg>
        } @else {
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        }
      </button>
      </div>
    </div>

    <button type="button" class="link-forgot" (click)="onForgotPassword()">Esqueci minha senha</button>

    <button type="submit" class="btn-entrar" [disabled]="loading()">
      {{ loading() ? 'Entrando...' : 'Entrar' }}
    </button>

    <p class="separator">OU</p>

    <div class="social-buttons-row" role="group" aria-label="Entrar com rede social">
      <button type="button" class="btn-social btn-google" (click)="onGoogleLogin()">
        <img
          class="google-logo"
          src="/images/google-logo.png"
          alt=""
          width="20"
          height="20"
          decoding="async"
        />
        Google
      </button>
      <button type="button" class="btn-social btn-apple" (click)="onAppleLogin()">
        <svg class="apple-logo" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" aria-hidden="true">
          <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
        </svg>
        Apple
      </button>
    </div>

    <p class="register-line">
      Ainda não possui uma conta?
      <button type="button" class="link-register" (click)="onRegister()">Cadastre-se</button>
    </p>
  </form>
</app-modal>
